import { z } from "zod";
export const emailProcessingStatus = {
    PROCESSED: "processed",
    PROCESSED_WITH_HELP: "processed_with_help",
    SKIPPED: "skipped",
};
export const processEmailInputSchema = z.object({
    emailNumber: z.int().positive(), // 1-based email number within the inbox bucket session
    messageId: z.uuid(),
    eclaimHref: z.url(),
    sender: z.string(),
    receivedAt: z.iso.datetime(),
    subject: z.string(),
});
export const processEmailResultSchema = z.object({
    status: z.enum([emailProcessingStatus.PROCESSED, emailProcessingStatus.PROCESSED_WITH_HELP, emailProcessingStatus.SKIPPED]),
    comment: z.string().optional(),
});
